import request from '@/utils/request'

export function hycot101(param) {
    let data = param
    return request({
        url: `/invoice/hycot101`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function deleteInvoice(param) {
    let data = param
    return request({
        url: `/invoice/deleteInvoice`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function makeInvoice(param) {
    let data = param
    return request({
        url: `/invoice/makeInvoice`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}